import { CharacterGender } from "@1games-ru/region-shared/dist/enums/character/character";
import { DocumentData } from "@1games-ru/region-shared/dist/types/documents/documentData";
import { transliterate } from "transliteration";
import clsx from "clsx";
import { ChevronLeftIcon } from "@/shared/icons";

function Field({
  label,
  value,
  className,
  classNameValue,
  classNameLabel,
}: {
  label?: string;
  value: string;
  className?: string;
  classNameValue?: string;
  classNameLabel?: string;
}) {
  return (
    <div className={clsx("flex items-end gap-2.5", className)}>
      {label && (
        <div className={clsx("text-[#7E2C35] text-14 font-medium", classNameLabel)}>{label}</div>
      )}
      <div
        className={clsx(
          "border-b border-b-[#7E2C35] text-center text-dark-800 text-15 uppercase",
          classNameValue,
        )}
      >
        {value}
      </div>
    </div>
  );
}

export default function Passport({ docNumber, owner, issuedAt }: DocumentData) {
  console.log({ owner, docNumber });
  return (
    <div
      className="grid grid-rows-2 w-[34.2rem] h-[40rem] rounded-[1.25rem] overflow-clip bg-[#E6C7CB]"
      style={{
        backgroundImage: "url(./svg/documents/passport.webp)",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
      }}
    >
      <div
        className={clsx(
          "relative px-[1.875rem] py-[1.875rem] pr-[3.75rem]",
          "flex flex-col items-center gap-[1.5rem]",
        )}
      >
        <div
          className={clsx(
            "absolute text-[#7E2C35] text-16 font-medium uppercase tracking-[0.625rem]",
            "rotate-90 -right-[2.5rem] top-1/2 w-[10rem] text-center",
          )}
        >
          {docNumber}
        </div>
        <div className="text-[#7E2C35] text-16 font-medium uppercase tracking-[0.5rem]">
          ПАСПОРТ РЕГИОНА
        </div>
        <Field
          label="Паспорт выдан"
          value="Отделом УФМС РЕГИОНА"
          className="w-full"
          classNameValue="grow"
        />
        <Field value="гор. САНКТ-ПЕТЕРБУРГ" className="w-full" classNameValue="pl-[6rem] w-full" />
        <div className="flex items-end gap-2.5 w-full">
          <Field label="Дата выдачи" value={issuedAt} className="grow" classNameValue="grow" />
          <Field label="Код подразделения" value="780-035" className="grow" classNameValue="grow" />
        </div>
        <div className="w-full mt-auto flex items-end justify-between">
          <div className="h-[1.25rem] w-[8.125rem] relative border-t border-[#7E2C35] text-[#7E2C35] text-14 font-medium text-center">
            <img
              src="./svg/dark-signature.svg" // TODO: {issuer.signature}
              className="absolute h-[4rem] w-full -top-[3rem]"
              alt=""
            />
          </div>
          <img
            src="./svg/documents/seal-migration-service.webp"
            alt=""
            className="z-1 w-[6.25rem] aspect-square absolute left-[10.5rem] pointer-events-none"
          />
          <div className="h-[1.25rem] w-[12.75rem] relative border-t border-[#7E2C35] text-[#7E2C35] text-14 font-medium text-center">
            {owner?.signature && (
              <div
                className="absolute h-[4rem] w-full -top-[3rem]"
                style={{
                  backgroundImage: `url(${import.meta.env.VITE_CDN_URL}/server/${import.meta.env.VITE_SERVER_NAME}/character/${docNumber}/documents/signature/passport/${owner.signature}/original.webp)`,
                  backgroundSize: "contain",
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                }}
              />
            )}
            Личная подпись
          </div>
        </div>
      </div>
      <div className={clsx("relative px-[1.875rem] py-[1.875rem] pr-[3.75rem]")}>
        <div
          className={clsx(
            "absolute text-[#7E2C35] text-16 font-medium uppercase tracking-[0.625rem]",
            "rotate-90 -right-[2.5rem] top-[8rem] w-[10rem] text-center",
          )}
        >
          {docNumber}
        </div>
        <div className="flex items-center gap-5 w-full mt-[2rem]">
          <div className="relative shrink-0 bg-white">
            <div
              className="w-[7.5rem] h-[8.75rem] border border-[#7E2C35] pointer-events-none"
              style={{
                backgroundImage: `url(${import.meta.env.VITE_CDN_URL}/server/${import.meta.env.VITE_SERVER_NAME}/character/${docNumber}/documents/photo/passport/${owner.photo}/original.webp)`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
              }}
            />

            <div
              className="absolute -top-[0.3rem] left-0 right-0  h-[0.625rem]"
              style={{
                backgroundImage: "url(./svg/documents/red-photo-border-g.svg)",
                backgroundRepeat: "no-repeat",
                backgroundSize: "contain",
              }}
            />
            <div
              className="absolute -top-[0.3rem] -left-[0.3rem] h-[7.5rem] w-[0.625rem]"
              style={{
                backgroundImage: "url(./svg/documents/red-photo-border-v.svg)",
                backgroundRepeat: "no-repeat",
                backgroundSize: "contain",
              }}
            />
          </div>
          <div className="grow flex flex-col">
            <Field label="Фамилия" value={owner.lastName} className="grow" classNameValue="grow" />
            <Field
              label="Имя"
              value={owner.firstName}
              className="grow mt-[1.5rem]"
              classNameValue="grow"
            />
            <div className="flex items-end gap-2.5 mt-[0.5rem]">
              <Field
                label="Пол"
                value={owner.sex === CharacterGender.Female ? "Ж." : "М."}
                className="grow"
                classNameValue="grow"
              />
              <Field
                label="Дата Рождения"
                value={owner.dateOfBirth}
                className="grow"
                classNameLabel="w-[4.25rem] break-words"
                classNameValue="grow"
              />
            </div>
            <Field
              label="Место Рождения"
              value="гор. Санкт-Петербург"
              className="grow mt-[0.5rem]"
              classNameLabel="w-[4.25rem] break-words"
              classNameValue="grow"
            />
          </div>
        </div>
        <div
          className={clsx(
            "absolute bottom-0 left-0 right-0 h-[4.375rem] px-[1.875rem]",
            "flex items-center justify-between gap-2.5 bg-[#F9EBEE]/50",
            "text-dark-800 text-12 font-medium tracking-[2px] uppercase",
          )}
        >
          <div>{transliterate(owner.firstName)}</div>
          <div className="flex items-center">
            <ChevronLeftIcon size={10} />
            <ChevronLeftIcon size={10} className="-translate-x-0.5" />
          </div>
          <div>{transliterate(owner.lastName)}</div>
          <div className="flex items-center">
            <ChevronLeftIcon size={10} />
            <ChevronLeftIcon size={10} className="-translate-x-0.5" />
          </div>
          <div>01032026</div>
          <ChevronLeftIcon size={10} />
          <div>12122025</div>
        </div>
      </div>
    </div>
  );
}
